import {
    createQuestion,
    updateQuestion,
    createOption,
    updateOption,
    generateUUID,
    stringToHTML
} from "../helper";

import tippy from 'tippy.js';
import Swal from 'sweetalert2';
import Vue from 'vue';
import AppEditor from '~/components/AppEditor';
import { optionsIcon }  from '~/assets/icons/js/optionsIcon';

export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const SM = editor.StorageManager;
    const COMMANDS = editor.Commands;
    const MD = editor.Modal;
    const TYPE = DOMC.getType('C-QUESTION');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    const FORMAT_1 = "select";
    const FORMAT_2 = "radio";
    const TYPE_1 = "C-SELECT-OPTIONS";
    const TYPE_2 = "C-RADIO-GROUP";
    const DEFAULT_OPTIONS = [
        {
            key:generateUUID(),
            label:"Option 1",
            value:null,
            coregistros:[]
            
        },
        {
            key:generateUUID(),
            label:"Option 2",
            value:null,
            coregistros:[]
        }
    ]

    var model = MODEL.extend({
        defaults:{
            ...MODEL.prototype.defaults,
            tagName:'div',
            droppable: ':not([data-slg-custom-menu="true"])',
            draggable: ':not([data-slg-custom-menu="true"])', 
            attributes:{
                ...MODEL.prototype.defaults.attributes,
                class:"form-group",
                name:"options",
                "data-slg-type":"C-QUESTION-OPTIONS",
                "data-slg-custom-menu":true,
                "data-slg-format":"select",
                "data-slg-options":"[]",
                "data-slg-has-client":false,
                required: true
            },
            traits: [
                {
                    type: 'text',
                    name: 'id',
                },
                {
                    type: 'checkbox',
                    name: 'required',
                }
            ],
            style:{
                padding:"0.5em"
            },
            components:[
                ...MODEL.prototype.defaults.components,
                {
                    type:'row',
                }
            ],
            options: [],
            format:"select",
            visible_condition:true,
        },
        init() {
            let component = this;
            let attributes = component.get('attributes');
            let options = JSON.parse(attributes['data-slg-options']);
            if(options.length == 0){
                this.set('attributes',{
                    ...attributes,
                    "data-slg-options":JSON.stringify(DEFAULT_OPTIONS)
                })
            }
        },
        getOptions(){
            let component = this;
            let attributes = component.get('attributes');
            return JSON.parse(attributes['data-slg-options']);
        },
        setOptions(options){
            let component = this;
            component.addAttributes({
                "data-slg-options":JSON.stringify(options)
            });
        },
        getComponentQuestionOptions() {
            let component = this;
            let component_options = component.findType(TYPE_1)[0];
            if(!component_options){
                component_options = component.findType(TYPE_2)[0];
            }
            if(!component_options){
                component_options = component.components().at(1);
            }
            return component_options;
        },

        /**
         * @function registerOption
         * @param {Object} option Object option wiht params key,label,value
         * @description  If the option does not have UUID it will be registered, if it has UUID it will update the option.
         * @returns Option object with updated parameters
         */
        async registerOption(option){

            let storage_manager_steps = SM.get(opts.storage_name);
            let storage_steps_active = storage_manager_steps.isActive();
            let current_step = storage_manager_steps.current_step;

            let component = this;
            let attributes = component.get('attributes');
            let template_step_id = attributes['data-slg-template-step-id'];
            let question_id = attributes['data-slg-question-id'];
            let resp = option;
            let client_id = (option.coregistros && option.coregistros.length > 0)? option.coregistros[0].client:0;
            let option_text = stringToHTML(option.label).innerText.trim();
            if((option.value && !storage_steps_active ) || (option.value && storage_steps_active && template_step_id != "" && (current_step == template_step_id))){
                await updateOption(option_text,option.value, client_id);
                return resp;
            }
            resp.value = await createOption(option_text,question_id, client_id);
            return resp;
        },

        async createAllOptions(){
            let component = this;      
            let options = component.getOptions();

            let component_options = component.getComponentQuestionOptions();
            component_options.cleanOptions(options);
            for (let op of options) {
                op = await component.registerOption(op);
                component_options.renderOption(op);
            }
            component.setOptions(options);
            
        },
        createCoregistroContainer(){
            let component = this;
            let attributes = component.get('attributes');
            let container_coregistro = component.getComponentContainerCoregistro();
            if(component.hasCoregistro()){
                component.set('attributes',{
                    ...attributes,
                    "data-slg-has-client":true
                })
                let coregistros = component.getCoregistros();
                if(container_coregistro){
                    // update container
                    let container_coregistro_attributes = container_coregistro.get('attributes');
                    if((coregistros[0].confirmation_type != container_coregistro.getConfirmationType())  || 
                        (coregistros[0].required_acceptance != container_coregistro.getRequiredAcceptance())){
                        let attributes = {
                            ...container_coregistro_attributes,
                            "data-slg-confirmation-type":coregistros[0].confirmation_type,
                            "data-slg-required-acceptance":`${coregistros[0].required_acceptance}`,
                        }
                        container_coregistro.setAttributes(attributes);
                    }
                }else{
                    component.append({
                        type:'C-CONTAINER-COREGISTRO',
                        attributes:{
                            "data-slg-confirmation-type":coregistros[0].confirmation_type,
                            "data-slg-required-acceptance":`${coregistros[0].required_acceptance}`,
                        }
                    });
                }
                
            }else{
                component.set('attributes',{
                    ...attributes,
                    "data-slg-has-client":false
                })
                if(container_coregistro){
                    container_coregistro.remove();
                }
                
            }
        },
        getComponentContainerCoregistro(){
            let component = this;
            let find = component.findType('C-CONTAINER-COREGISTRO');
            return (find.length > 0) ? find[0]:undefined;
        },
        
        getCoregistros(){
            let component = this;
            let options =  component.getOptions();
            let find_option_coregistros = options.find((item)=>{
                return item.coregistros.length > 0
            })
            return find_option_coregistros.coregistros;
        },
        hasCoregistro(){
            let component = this;
            let options =  component.getOptions();
            let find_option_coregistros = options.findIndex((item)=>{
                return item.coregistros.length > 0
            })
            return (find_option_coregistros != -1 ) ? true:false;
        },
        async registerQuestionWithCoregistro(){
            let component = this;
            
            let storage_manager_steps = SM.get(opts.storage_name);
            let storage_steps_active = storage_manager_steps.isActive();
            let current_step = storage_manager_steps.current_step;

            let question_text = component.getComponentQuestionText().getContent();
            question_text = stringToHTML(question_text).innerText.trim();
            let attributes = component.get('attributes');
            let question_id = attributes['data-slg-question-id'];
            let template_step_id = attributes['data-slg-template-step-id'];
            if( (question_id  && !storage_steps_active) || (question_id && storage_steps_active && (current_step == template_step_id)) ){
                let has_client = component.hasCoregistro();
                has_client = has_client ? 1:0;
                await updateQuestion(question_text,question_id, has_client);
                return
            }
            question_id = await createQuestion(question_text);
            component.set('attributes',{
                ...attributes,
                'data-slg-question-id':question_id
            });
        },
        watchOptionLabel(){
            let component = this;
            let component_options = component.getComponentQuestionOptions();
            let options_labels = component_options.findType('label');
            let options = component.getOptions();
            for (let i = 0; i < options_labels.length; i++) {
                const label = options_labels[i];
                let option = options[i];
                label.listenTo(label,'change:content',model =>{
                    //const text_label = label.components().at(0).get('content');
                    const text_label = label.get('content');
                    if(text_label != option.label && text_label.length > 0){
                        option.label = text_label;
                        component.registerOption(option);
                        component.setOptions(options);
                        editor.store();
                    }
                })
            }
        },
        /**
         * @function controlFormat
         * @description It controls the current format of the component and if there is any change it initializes it.
         * @returns true or false if there is any change.
         */
        controlFormat(){
            let component = this;
            let attributes = component.get('attributes');
            let format = attributes['data-slg-format'];
            let question_id = attributes['data-slg-question-id'];
            let changed = false;
            let component_options = component.getComponentQuestionOptions();
            let type = component_options.attributes.type;
            
            if( format == FORMAT_1 && (type == TYPE_2 || type != TYPE_1 ) ){        
                
                component_options.replaceWith({
                    type:TYPE_1,
                    question_id
                });
                changed = true;
                
            }
            if( format == FORMAT_2 && (type == TYPE_1 || type != TYPE_2 )){
                
                component_options.replaceWith({
                    type:TYPE_2,
                    question_id
                });
                changed = true;
            }
            return changed;
        },
        changeFormat(){

            let component = this;
            component.controlFormat();

            let options = component.getOptions();
            // let component_options = this.model.components().at(1);
            let component_options = component.getComponentQuestionOptions();
            // Control the current format component.
            
            for (let op of options) {  
                component_options.renderOption(op);
            }

            component.setOptions(options);
            component.watchOptionLabel();
            
        },
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-QUESTION-OPTIONS")
                return { type:'C-QUESTION-OPTIONS' }
        },
    });

    var view = VIEW.extend({
        init2(){
            let component = this.model;
            /* this.listenTo(component, 'change:attributes:data-slg-format', component.changeFormat); */
        },
        /**
         * Trigger when the render is completed
         */
        onRender() {
            let component = this.model;
            let storage_steps = SM.get(opts.storage_name);
            let order_step = storage_steps.getOrderStep(storage_steps.getCurrentStep());
            if( order_step == 0 ){
                Swal.fire({
                    icon:'warning',
                    title: '¡Alert!',
                    text: "The question component and coregisters cannot be created in the template and step 0",
                    heightAuto:false,
                    
                });
                component.remove();
                return;
            }
            this.updateComponent();
            this.createCustomMenu();
            component.watchQuestionText();

        },
        updateComponent:async function () {
            let component = this.model;
            if (!component) {
                return;
            }
            component.createCoregistroContainer();
            // Render the question
            await component.registerQuestionWithCoregistro();
            // Control the current format component.
            component.controlFormat();

            // Render the options
            await component.createAllOptions();

            component.watchOptionLabel();
            
            await component.registerQuestionByStep();

        },
        
        /**
         * @function createCustomMenu
         * @description Create a custom tooltip menu in the editor view.
         */
        createCustomMenu: function(){
            let el = this.el;
            var self = this;
            var component = this.model;
            let wrapperEl = editor.getWrapper().view.el;
            let tooltip = /*html*/
            `
            <div id="template">
                <ul class="list-toggle">
                    <li class="item add">
                        <i class="far fa-plus-square"></i>
                    </li>
                    <li class="item exchange">
                        <i class="fas fa-sync"></i>
                    </li>
                    <li class="item coregistro">
                        <i class="far fa-eye"></i>
                    </li>
                    <li class="item config" data-toggle="modal" data-target="#staticBackdrop">
                        <i class="fas fa-cog fa-1x"></i>
                    </li>
                </ul>
            </div>
            `
            
            const instance = tippy(el, {
                content: tooltip,
                allowHTML: true,
                trigger: 'click',
                theme: 'light',
                interactive: true,
                zIndex: 100,
                arrow: true,
                onCreate(instance) {
                    let itemConfig = instance.popper.querySelector('.item.config');
                    itemConfig.addEventListener('click',(e) =>{
                        e.preventDefault();
                        editor.runCommand('open-modal-question-options', { component });
                        instance.hide();
                    });

                    let item_exchange = instance.popper.querySelector('.item.exchange');
                    item_exchange.addEventListener('click',(e) =>{
                        e.preventDefault();
                        editor.runCommand('exchange-shape-question-options', { component });
                        instance.hide();
                    });

                    let item_coregistro = instance.popper.querySelector('.item.coregistro');
                    item_coregistro.addEventListener('click',(e) =>{
                        e.preventDefault();
                        let component_container_coregistro = component.getComponentContainerCoregistro();
                        if(component_container_coregistro)
                            component_container_coregistro.view.toggle();
                        instance.hide();
                    });


                    let item_add = instance.popper.querySelector('.item.add');
                    item_add.addEventListener('click',async (e) =>{
                        e.preventDefault();

                        let option = {
                            key:generateUUID(),
                            label:"Option default",
                            value:null,
                            coregistros:[]
                        }
                        option = await component.registerOption(option);
                        let options = component.getOptions();
                        options.push(option);
                        component.setOptions(options);
                        let component_options = component.getComponentQuestionOptions();
                        component_options.renderOption(option);
                        component.watchOptionLabel();
                        instance.hide();
                    });

                },
            });
            
            
        }

    });

    DOMC.addType('C-QUESTION-OPTIONS', {
      model:model,
      view:view,
    });

    BM.add('B-QUESTION-OPTIONS', {
        label:"QUESTION OPTIONS",
        content: {
            type: 'C-QUESTION-OPTIONS',
        },
        category:"LEADGREASE INTEGRATION",
        media: optionsIcon,
    });

    COMMANDS.add('open-modal-question-options',{
        run: function (editor, sender, params) {
            let component = params.component;
            let options = component.getOptions();
            let question_text = component.getComponentQuestionText().getContent();
            let format = component.get('attributes')['data-slg-format'];
            let name = component.get('attributes')['name'];
            let id = component.getId();

            let container = document.createElement('div');
            container.setAttribute('id','vue-app');

            MD.setTitle("Question options")
                .setContent(container)
                    .open();

            new Vue({
                ...AppEditor,
                element:"ModalQuestionOptions",
                editor,
                opts,
                payload:{
                    component,
                    question_text,
                    options,
                    attributes:{
                        format,
                        name,
                        id
                    }
                }
            }).$mount('#vue-app');

        }
    });
    COMMANDS.add('update-model-question-options',{
        run: function (editor, sender, params) {
            let component = params.component;
            let options = params.options;
            let format = params.format;
            let question_text = params.question_text;
            let name = params.name;
            let id = params.id;
            let required = params.required;
            component.set({
                required,
                attributes:{
                    ...component.get('attributes'),
                    "data-slg-format":format,
                    name,
                    id
                }
            });
            component.setOptions(options);
            component.setComponentQuestionTextContent(question_text);
            // component.setQuestionText(question_text);
            component.view.updateComponent();
            
        }
    });

    COMMANDS.add('exchange-shape-question-options',{
        run:function (editor,sender,params){
            const component = params.component;
            let attributes = component.get('attributes');
            let format = attributes['data-slg-format'];

            if(format == FORMAT_1){
                component.setAttributes({
                    ...attributes,
                    'data-slg-format':FORMAT_2
                });
            }else{
                component.setAttributes({
                    ...attributes,
                    'data-slg-format':FORMAT_1
                });
            }

            component.changeFormat();
            
        }

    });
};
  